<template>
    <span>
      <modal v-on:close="closeForm" :show="showModal" modal-id="lineItemModal" headerClasses="justify-content-center">
        <h4 slot="header" class="title title-up">Invite Partner Nation</h4>
      <hr />
        <label style="padding-top: 10px;">Partner Nation Email:</label>
          <base-input
            type="text"
            name="email"
            placeholder="Enter Official Government E-mail"
            :error="getError('email')"
            data-vv-as="email"
            required
            v-validate="userValidations.email"
            v-model="email"
          ></base-input>
          <p v-if="emailRequired" style="color:red">An email is required </p>
          <label style="padding-top: 10px;">Partner Nation:</label>
          <treeselect
                        
                        class="select-primary"
                        v-model="countryId"
                        name="organization"
                        :options="managedCountryIds"
                        :multiple="false"
                        v-validate="userValidations.countryId"
                        :required="true"
                      />
                      <p v-if="countryRequired" style="color:red"> A Partner Nation is required </p>
          
          <template slot="footer">
        <div class="container alert_footer">
         
          <base-button
            type="danger"
            class="alert_footer_button btn_extra_small btn_info mr-4"
            @click.native="closeForm"
          >
            Cancel
          </base-button>
           <base-button
            :disabled="isPartnerAccount"
            type="primary"
            class="alert_footer_button btn_extra_small btn_info"
            @click.native="submit"
          >
            Send e-mail
          </base-button>
          
        </div>
      </template>
      </modal>
    </span>
  </template>
  
  <script>
import axios from "@/axios";
import { mapGetters, mapActions } from "vuex";
import { BaseButton, Modal } from "@/components";
import VeeValidate from "vee-validate";
import Treeselect from "@riophae/vue-treeselect";
import { Select } from "element-ui";
import _ from 'lodash'
  
  export default {
    name: "line-item-modal",
    props: {
       showLineItemModal: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        email:null,
        countryId: null,
        countryRequired:false,
        managedCountryIds: [],
        emailRequired: false,
        userValidations: {
          email: {
            required: true,
            email: true,
          }
        },
        modals: {
          classic: false,
        },
        closeModal: true,
      };
    },
    components: {
      BaseButton,
      Modal,
      VeeValidate,
      Treeselect,
      [Select.name]: Select,
      
    },
    computed: {
      ...mapGetters({
        user: "users/user",
        isPartnerAccount: "authentication/isPartnerAccount",
        countrySummaryList: "orderReport/countrySummaryList",
        activePartnerCountries: "countries/activePartnerCountries",
      }),
      showModal() {
        this.$validator.reset();
        this.email = ''
        return this.showLineItemModal || this.modals.classic;
      }
    },
    async mounted() {
      this.closeModal = true;
      await this.getUserByEmail();
      await this.getAllCountries();
      await this.getAllActivePartnerCountries();
      await this.getManagedCountries();
    },
    methods: {
      ...mapActions({ 
      getUserByEmail: 'users/getUserByEmail',
      getAllCountries: "countries/getAllCountries",
      getAllActivePartnerCountries : "countries/getAllActivePartnerCountries"
      
    }),
    closeForm() {
      this.modals.classic = false;
      this.$emit('modal-closed');
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },

    async getManagedCountries(){
      if(this.user.countriesToManage &&  this.activePartnerCountries ){
      let allActiveCountries = await this.activePartnerCountries.map(a => ({'label': a.name, 'id': a.countryId }))
      let managedCountries = await this.user.countriesToManage.map(a => ({'label': a.name, 'id': a.countryId }));
      let result =   _.intersectionWith(allActiveCountries, managedCountries, _.isEqual);
      this.managedCountryIds = result
      }
      
    },
   
      submit(e) {  
          let email = this.email
          let countryId = this.countryId
            if (email && countryId) {
                //const email = this.email;
                const inviteDto = { 
                  PartnerNationUserEmail: this.email,
                  CountryId: this.countryId
                };
                this.email;
                axios
                    .post("api/authentication/invitepartnernation", inviteDto, { config: { showToast: false } })
                    .then((response) => {
                        this.$toast.success(response.data || 'Invitation sent successfully');
                        this.closeForm()
                    })
                    .catch((error) => {
                        this.$toast.error('Invite not sent!');
                        
                    });
            }else if(!email){
              this.emailRequired = true
              this.countryRequired = false
            }else if(!countryId){
              this.countryRequired = true
              this.emailRequired = false
                      }
      },
     
    },
  };
  </script>
  
  <style>
  .has-danger .vs__dropdown-toggle {
    border-color: #ec250d !important;
  }
  
  .error {
    color: #ec250d;
    font-size: 0.75rem;
  }
  </style>
  